import { render, staticRenderFns } from "./configAddGroup.vue?vue&type=template&id=48723863&"
import script from "./configAddGroup.vue?vue&type=script&lang=js&"
export * from "./configAddGroup.vue?vue&type=script&lang=js&"
import style0 from "./configAddGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports